import { Pipe, PipeTransform } from '@angular/core';
import { TypesUtil } from '@liberty-financial/ng-core';

@Pipe({
  name: 'yesNoNotGiven',
})
export class YesNoNotGivenPipe implements PipeTransform {
  transform(value: boolean | null, transformUndefined: boolean = false): string | null {
    if (TypesUtil.isUndefined(value) || value === null) {
      return transformUndefined ? 'no' : null;
    }

    return value ? 'yes' : 'no';
  }
}